// Click one element to toggle another element
// To use, add a `data-toggle` attribute whose value is a selector
// for the target element(s).
$("[data-toggle]").click(event => {
  $(event.target.dataset.toggle).toggle()
})
